"use client";

import { motion } from "framer-motion";
import {
  Palmtree,
  Sparkles,
  Briefcase,
  PartyPopper,
  Crown,
  Heart,
} from "lucide-react";

const PORTFOLIO = [
  {
    icon: Palmtree,
    title: "Luxury Vacations",
    description:
      "Private villa stays for families, couples, and groups looking for comfort, exclusivity, and memorable holidays.",
  },
  {
    icon: Sparkles,
    title: "Bespoke Experiences",
    description:
      "Curated stays, personalised itineraries, private dining, celebration planning, destination experiences, and travel moments crafted around each guest.",
  },
  {
    icon: Briefcase,
    title: "Corporate Luxe Events",
    description:
      "Premium offsites, leadership retreats, team gatherings, strategy meets, brand experiences, and intimate corporate events hosted in private luxury settings.",
  },
  {
    icon: PartyPopper,
    title: "Private Celebrations",
    description:
      "Elegant villas for birthdays, anniversaries, family milestones, reunions, festive gatherings, and intimate destination celebrations.",
  },
  {
    icon: Crown,
    title: "Executive Corporate Hospitality",
    description:
      "Private luxury stays and curated hospitality for leadership visits, corporate guests, client hosting, and premium business travel.",
  },
  {
    icon: Heart,
    title: "Destination Weddings",
    description:
      "Beautiful private settings for boutique weddings, engagement ceremonies, pre-wedding events, and exclusive social gatherings with a luxury hospitality experience.",
  },
];

export function AboutPortfolio() {
  return (
    <section className="section-padding bg-gradient-to-b from-background via-card/20 to-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-primary">
            What We Offer
          </p>
          <h2 className="mt-3 font-playfair text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
            Our Experience Portfolio
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">
            Spaces and moments crafted to bring people together — for every
            kind of occasion.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3">
          {PORTFOLIO.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group relative overflow-hidden rounded-2xl border border-border/50 bg-card/60 p-7 transition-all duration-500 hover:border-primary/40 hover:bg-card/80 hover:shadow-2xl hover:shadow-primary/10"
              >
                <div className="absolute -right-12 -top-12 size-40 rounded-full bg-primary/5 blur-3xl transition-all duration-500 group-hover:bg-primary/10" />

                <div className="relative">
                  <div className="flex size-12 items-center justify-center rounded-xl bg-primary/10 ring-1 ring-primary/20 transition-all duration-500 group-hover:bg-primary/20 group-hover:ring-primary/40">
                    <Icon className="size-6 text-primary" />
                  </div>

                  <h3 className="mt-5 font-playfair text-xl font-semibold text-foreground md:text-2xl">
                    {item.title}
                  </h3>

                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
